import { Routes } from '@angular/router';
import { CampaignsComponent } from '@brightside-web/desktop/feature/campaigns';

export const campaignsRoutes: Routes = [
  {
    path: 'campaigns/:route',
    component: CampaignsComponent,
  }
]
